var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0853 24.9916V23.4424C8.0135 21.5859 5.48926 17.9665 5.48926 14.12C5.48926 7.50889 11.5661 2.32684 18.431 3.82269C21.4494 4.49048 24.0939 6.49385 25.4695 9.2585C28.2609 14.8679 25.3226 20.8246 21.0087 23.429V24.9783C21.0087 25.3656 21.1556 26.2604 19.7265 26.2604H12.3675C10.8984 26.2738 11.0853 25.6995 11.0853 24.9916Z",
    stroke: "white",
    strokeWidth: 2.00337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3525 30.28C14.411 29.4119 17.6431 29.4119 20.7016 30.28",
    stroke: "white",
    strokeWidth: 2.00337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.57bb53a2.svg";
export { ForwardRef as ReactComponent };